module.exports = __webpack_public_path__ + "img/hero-devil-oni.4ce969a8.png";